import { render, staticRenderFns } from "./advert-specs.vue?vue&type=template&id=e68cf94e"
import script from "./advert-specs.vue?vue&type=script&lang=ts"
export * from "./advert-specs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports